import React from 'react'
import OrderScreen from '../Components/UserPanel/OrderScreen'

const Order = () => {
    return (
        <>
        <OrderScreen />
        </>
    )
}

export default Order